import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Page introuvable | Aspexit</title>
      </Helmet>
      <div className="container mx-auto px-4 py-24 text-center">
        <h1 className="text-6xl font-heading font-extrabold text-aspexit-black mb-6">
          404
        </h1>
        <p className="text-xl text-aspexit-gray mb-8">
          {t('common.error')}
        </p>
        <Button asChild className="bg-aspexit-green hover:bg-aspexit-green-dark">
          <Link to="/">{t('common.back')}</Link>
        </Button>
      </div>
    </>
  );
}
